import { Link } from "react-router-dom"
import canAccess from "../../services/accessService/accessService"
import { BoxArrowUpRight } from "react-bootstrap-icons"

export default function PropertyLinkIcon(props: {
    propertyId?: string,
    size?: number,
    viewBox?: string
}) {
    const {
        propertyId,
        size,
        viewBox
    } = props
    return (
        <>
            {canAccess('routes', 'property') && propertyId && (
                <Link to={`/property/${propertyId}`} className="ms-2">
                    <BoxArrowUpRight size={size} viewBox={viewBox} />
                </Link>
            )}
        </>
    )
}